import Vue from 'vue';
import AppConfigService from './service/AppConfigService'

const state = Vue.observable({
	modules: [],
	enums: [],
});


export const getters = {
	modules: () => state.modules,
	enums: () => state.enums,

}

export const mutations = {
	setModules: (val) => state.modules = val,
	setEnums: (val) => state.enums = val,

}

export const actions = {
	async loadModules() {
		const service = new AppConfigService();
		const modules = await service.getAllModules();
		mutations.setModules(modules);
	},
	async loadEnums() {
		const service = new AppConfigService();
		const enums = await service.getAllEnums();
		mutations.setEnums(enums);
	},
}